module.exports = __webpack_public_path__ + "img/icon26.b4ccf5ae.svg";